import { createContext } from 'react';

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
export const AuthContext = createContext({ isAuthed: false, setIsAuthed: (val: boolean) => {} });
